export default {
  "content": "<g clip-path=\"url(#clip0_4511_459)\" fill=\"#ff00cb\" fill-opacity=\".9\"><path d=\"M4.26 6.01L2.85 4.6c5.46-5.46 14.34-5.46 19.79 0l-1.41 1.41c-4.68-4.68-12.29-4.68-16.97 0z\"/><path d=\"M5.68 7.43l1.41 1.41a7.949 7.949 0 015.66-2.34c2.14 0 4.15.83 5.66 2.34l1.41-1.41a9.932 9.932 0 00-7.07-2.93c-2.67 0-5.18 1.04-7.07 2.93z\"/><path d=\"M8.51 10.26l1.41 1.41a4.004 4.004 0 015.66 0l1.41-1.41a5.928 5.928 0 00-4.24-1.76c-1.6 0-3.11.62-4.24 1.76zM17.75 16.5c0-.55-.45-1-1-1h-8c-.55 0-1 .45-1 1v8h-2v-8c0-1.66 1.34-3 3-3h8c1.66 0 3 1.34 3 3v8h-2v-8z\"/></g><defs><clipPath id=\"clip0_4511_459\"><path fill=\"#fff\" transform=\"translate(.75 .5)\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "25",
    "height": "25",
    "viewBox": "0 0 25 25",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};